import { render, staticRenderFns } from "./ChannelsSecondChannelPromoBanner.vue?vue&type=template&id=86157f44&scoped=true"
import script from "./ChannelsSecondChannelPromoBanner.vue?vue&type=script&lang=js"
export * from "./ChannelsSecondChannelPromoBanner.vue?vue&type=script&lang=js"
import style0 from "./ChannelsSecondChannelPromoBanner.vue?vue&type=style&index=0&id=86157f44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86157f44",
  null
  
)

export default component.exports